import { styles } from "@repo/helpers";
import { Button, ButtonTypes, DropDownList, TextBox } from "@repo/ui";
import { ChevronLeft, ChevronRight } from "lucide-react";

import { AddressDropdown } from "../../components/addressDropdown";
import { useMapFilters } from "./filters/filterContext";
import { PANEL_IDS } from "./panels";
import { SlidePanel } from "./slidePanel";

const SHAPE_OPTIONS = [
	{ value: "square", label: "Square" },
	{ value: "circle", label: "Circle" },
];

interface RightSidebarProps {
	open: boolean;
	closing: boolean;
	onToggle: () => void;
	onClose: () => void;
	onClosed: () => void;
}

export function RightSidebar({ open, closing, onToggle, onClose, onClosed }: RightSidebarProps) {
	const { filters, filterChanged } = useMapFilters();
	const toggleLabel = open ? "Collapse search panel" : "Open search panel";

	return (
		<>
			<div className="hidden h-full w-10 shrink-0 flex-col items-center border-l border-border bg-background lg:flex">
				<Button
					types={[ButtonTypes.Text]}
					onClick={onToggle}
					className="flex h-11 w-full items-center justify-center"
					aria-label={toggleLabel}
					aria-expanded={open}
					aria-controls={PANEL_IDS.search}
					title={toggleLabel}
				>
					{open ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
				</Button>
			</div>

			<SlidePanel
				id={PANEL_IDS.search}
				title="Geographic View"
				side="right"
				open={open}
				closing={closing}
				onClose={onClose}
				onClosed={onClosed}
				className={styles(
					"w-[min(20rem,88vw)] overflow-hidden",
					"lg:static lg:z-auto lg:translate-x-0 lg:shadow-none lg:ease-in-out",
					open ? "lg:w-72" : "lg:w-0 lg:border-l-0",
				)}
				contentClassName="w-[min(20rem,88vw)] lg:w-72"
				headerClassName="lg:h-auto lg:py-3"
				closeClassName="lg:hidden"
			>
				<div className="flex-1 space-y-4 overflow-y-auto overflow-x-hidden p-4">
					<AddressDropdown
						label="Point of Interest"
						placeholder="Search Addresses..."
						id="poi"
						value={filters.poi}
						changeHandler={filterChanged}
					/>
					<TextBox
						label="Distance (miles)"
						id="distanceMiles"
						type="number"
						min={0}
						value={filters.distanceMiles}
						changeHandler={filterChanged}
						className="m-0 w-full"
					/>
					<DropDownList
						label="Shape"
						id="distanceShape"
						values={SHAPE_OPTIONS}
						value={filters.distanceShape}
						changeHandler={filterChanged}
						fullLength
						className="m-0 w-full"
					/>
				</div>
			</SlidePanel>
		</>
	);
}
